// Note: Events are now prefixed automatically by the Dashboard context
// Components should emit generic events, and the context adds "Dashboard - " prefix
export const DASHBOARD_EVENTS = {
  MODEL_CHANGED: "Model Changed",
  MODE_CHANGED: "Mode Changed",

  CUSTOM_DATES_CHANGED: "Custom Dates Changed",
  DATE_SHORTCUT_CHANGED: "Shortcut Period Date Changed",
  END_DATE_RESET_TO_LATEST: "End Date Reset To Latest",
  PERIOD_SELECTED: "Period Selected",

  FILTERS_OPENED: "Filters Opened",
  FILTERS_CLOSED: "Filters Closed",
  FILTER_APPLIED: "Filter Applied",
  FILTER_CLEARED: "Filter Cleared",
  DATA_DOWNLOADED: "Data Downloaded",

  INITIAL_INSTRUMENT_SELECTION: "Initial Instrument Selection",
  COMPARISON_REMOVED: "Comparison Removed",
  COMPARISON_SEARCH_OPENED: "Comparison Search Opened",
  COMPARISON_SEARCH_SELECTION: "Comparison Search Selection",

  TRADE_ADDED: "Trade Added",
  TRADES_CLEARED: "Trades Cleared",

  BASE_SELECTION: "Base Selection",

  VIEW_OPENED: "View Opened",
  VIEW_PERMISSIONS_CLICKED: "View Permissions Clicked",
  VIEW_DELETED: "View Deleted",

  MODULE_ADDED: "Module Added",
  MODULE_REMOVED: "Module Removed",
  AI_ARTIFACT_EXPLAIN_STEPS_OPENED: "AI Artifact Explain Steps Opened",

  // TODO: Move these to their respective widget analytics contexts
  GRAPH_TEMPLATE_SELECTED: "Graph Template Selected",
  METRICS_SELECTOR_OPENED: "Metrics Selector Opened",
} as const

export type DashboardEventName = typeof DASHBOARD_EVENTS[keyof typeof DASHBOARD_EVENTS]
